<template>
  <q-tab-panels animated class="tab-panels bg-white text-dark col" keep-alive :model-value="value">
    <slot />
  </q-tab-panels>
</template>

<script>
export default {
  name: 'TabPanels',
  props: {
    value: String,
  },
};
</script>

<style lang="scss" scoped>
.q-tab-panels {
  max-width: 100%;

  @media (min-width: $breakpoint-sm) {
    border-radius: 0 0 4px 4px;
  }
}
</style>
